import React from "react";

const Inactive = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
    <circle cx="5" cy="5" r="5" fill="#E70000"/>
    <path d="M3 3L5 5M7 7L5 5M5 5L7 3L3 7" stroke="white"/>
    </svg>
);
export default Inactive;
